var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaurel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 171,
    viewBox: "0 0 292 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.592 128.668C206.706 133.169 203.705 142.952 207.525 151.041C215.412 146.539 218.413 136.756 214.592 128.668Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.035 159.505C224.114 163.945 214.183 161.476 209.219 154.035C217.14 149.595 227.071 152.063 232.035 159.505Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.606 118.778C222.436 124.35 220.85 134.459 225.777 141.925C232.946 136.353 234.532 126.243 229.606 118.778Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.238 146.835C244.025 152.352 233.845 151.314 227.878 144.65C235.09 139.134 245.271 140.172 251.238 146.835Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.979 107.922C234.907 114.674 235.134 124.905 241.303 131.382C247.374 124.63 247.148 114.399 240.979 107.922Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.23 131.713C261.107 138.418 250.903 139.196 243.852 133.693C249.975 126.988 260.179 126.21 267.23 131.713Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.05 96.0777C244.228 104.314 247.447 114.028 255.245 118.409C259.067 110.172 255.848 100.459 248.05 96.0777Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.126 111.115C276.24 119.322 266.714 123.061 258.358 119.869C262.244 111.663 271.77 107.924 280.126 111.115Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.606 82.5232C252.505 91.5366 258.558 99.7876 267.327 101.555C268.428 92.5418 262.375 84.2908 253.606 82.5232Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.757 86.9558C287.586 95.9603 279.674 102.45 270.741 101.986C271.912 92.9813 279.824 86.4914 288.757 86.9558Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.235 65.453C253.422 74.5314 260.583 81.8415 269.514 82.349C269.327 73.2705 262.165 65.9604 253.235 65.453Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.657 64.8607C288.774 73.9401 281.861 81.4855 272.953 82.2915C272.836 73.2121 279.749 65.6668 288.657 64.8607Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.78 49.36C252.797 58.3831 260.598 65.0064 269.538 64.6939C268.52 55.6708 260.719 49.0474 251.78 49.36Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.999 45.5255C287.947 54.5561 281.755 62.703 272.958 64.3215C272.01 55.2909 278.202 47.1441 286.999 45.5255Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.582 34.7799C249.013 43.1872 258.319 47.4424 266.838 44.7132C263.407 36.3058 254.1 32.0506 245.582 34.7799Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M278.437 21.5223C281.802 29.9558 278.056 39.4784 270.029 43.4258C266.664 34.9923 270.411 25.4696 278.437 21.5223Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.994 20.0448C241.549 27.9001 251.352 30.8342 259.414 26.9589C254.859 19.1035 245.056 16.1694 236.994 20.0448Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.713 2.39274C272.207 10.2831 269.806 20.2311 262.399 25.2453C257.905 17.3549 260.306 7.40695 267.713 2.39274Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3493 128.668C85.2357 133.169 88.2366 142.953 84.416 151.041C76.5296 146.54 73.5287 136.756 77.3493 128.668Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9067 159.505C67.8273 163.945 77.7585 161.476 82.7223 154.035C74.8016 149.595 64.8704 152.064 59.9067 159.505Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3356 118.778C69.5053 124.35 71.0913 134.459 66.1648 141.925C58.9952 136.353 57.4092 126.243 62.3356 118.778Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7035 146.835C47.916 152.352 58.0966 151.313 64.0635 144.65C56.851 139.133 46.6704 140.171 40.7035 146.835Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9607 107.922C57.0324 114.674 56.8058 124.905 50.6366 131.382C44.565 124.63 44.7916 114.399 50.9607 107.922Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7095 131.713C30.8329 138.418 41.0366 139.197 48.0879 133.693C41.9644 126.988 31.7608 126.21 24.7095 131.713Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8917 96.0774C47.7139 104.314 44.4944 114.027 36.6961 118.409C32.8739 110.172 36.0934 100.459 43.8917 96.0774Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8154 111.115C15.7012 119.322 25.2269 123.061 33.583 119.869C29.6971 111.662 20.1714 107.923 11.8154 111.115Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3334 82.5234C39.4346 91.5368 33.381 99.7878 24.6124 101.555C23.5112 92.542 29.5648 84.291 38.3334 82.5234Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.18444 86.9553C4.35524 95.9598 12.2675 102.45 21.2003 101.985C20.0295 92.9808 12.1172 86.4909 3.18444 86.9553Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7068 65.4528C38.5198 74.5312 31.3583 81.8413 22.4278 82.3487C22.6147 73.2703 29.7762 65.9602 38.7068 65.4528Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.284 64.8605C3.16725 73.9399 10.08 81.4852 18.9883 82.2913C19.1051 73.2118 12.1923 65.6665 3.284 64.8605Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1617 49.3602C39.144 58.3833 31.3432 65.0067 22.4038 64.6941C23.4214 55.671 31.2223 49.0477 40.1617 49.3602Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.94198 45.5258C3.99408 54.5564 10.1868 62.7032 18.9839 64.3218C19.9318 55.2911 13.7391 47.1443 4.94198 45.5258Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3574 34.7799C42.9269 43.1872 33.6201 47.4424 25.1018 44.7132C28.5323 36.3058 37.839 32.0506 46.3574 34.7799Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5043 21.5223C10.139 29.9558 13.8857 39.4784 21.9123 43.4258C25.2776 34.9923 21.5309 25.4696 13.5043 21.5223Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9475 20.0448C50.3928 27.9001 40.5891 30.8342 32.5273 26.9589C37.082 19.1035 46.8857 16.1694 54.9475 20.0448Z",
    fill: "black",
    fillOpacity: 0.4
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2283 2.39249C19.7343 10.2829 22.1353 20.2308 29.5428 25.245C34.0367 17.3546 31.6357 7.40671 24.2283 2.39249Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaurel);
export default __webpack_public_path__ + "static/media/laurel.d1e16134.svg";
export { ForwardRef as ReactComponent };